<template>
  <div class="main">
    <div class="inputs-container">
      <h1>语音练习</h1>
      <div class="input-row">
        <label>儿童姓名</label>
        <input type="text" v-model="name" />
      </div>
      <div class="input-row">
        <label>出生日期</label>
        <input type="date" v-model="birthay" />
      </div>
    </div>
    <button @click="onButton" class="start-button">开始</button>
  </div>
</template>

<script>
export default {
  name: 'ChildCreate',
  data() {
    return {
      birthay: new Date().toISOString().slice(0, 10),
      name: '',
    };
  },
  methods: {
    onButton() {
      console.log('-----', this.birthay, this.name);
    },
  },
};
</script>

<style scoped></style>
